import { render, staticRenderFns } from "./dish.vue?vue&type=template&id=b55e9aba&"
import script from "./dish.vue?vue&type=script&lang=js&"
export * from "./dish.vue?vue&type=script&lang=js&"
import style0 from "./dish.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports